import { useTranslation } from "react-i18next";
import { SearchField } from "@/components/ui/search-field";

/**
 * A compact "filter by name" field for the roles, sensors and dashboard lists — the shared {@link SearchField} with the
 * searchbox role. Filtering is the CALLER's (pure helpers over the lists); this only owns the text.
 */
export function FilterField({ label, placeholder, value, onChange, className }: { label: string; placeholder: string; value: string; onChange: (v: string) => void; className?: string }) {
  const { t } = useTranslation();
  return (
    <SearchField
      type="search"
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      clearLabel={t("roles.clearLabel", { label })}
      className={className}
    />
  );
}
